export const SET_CONTACT = 'SET_CONTACT';

/**
 * Change a setting value
 * payload.name: name of the setting prop to change
 * payload.value: new value to apply
 */
export function setContact(value) {
    return { type: SET_CONTACT, value };
}